import { FILE_TYPES } from '../constants/appConstants';

export const extractTextFromFile = async (file) => {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = async (event) => {
            try {
                let text = event.target.result;
                
                // For PDF files, you might want to use a PDF parsing library
                if (file.type === 'application/pdf') {
                    // Implementation for PDF parsing
                    // You might want to use a library like pdf.js
                }
                
                resolve(text);
            } catch (error) {
                reject(error);
            }
        };
        reader.onerror = () => reject(new Error('Failed to read file'));
        reader.readAsText(file);
    });
};

export const processFile = async (file) => {
    const isImage = file.type.startsWith('image/');
    const isPdf = file.type === 'application/pdf';
    const fileType = isImage ? FILE_TYPES.IMAGE : 
                    isPdf ? FILE_TYPES.PDF : 
                    FILE_TYPES.TEXT;

    let fileData = {
        file,
        originalName: file.name,
        type: file.type,
        fileType,
        preview: null,
        content: null
    };

    if (isImage || isPdf) {
        fileData.preview = URL.createObjectURL(file);
        // For PDF and images, we'll convert to base64 for API transmission
        try {
            const base64 = await fileToBase64(file);
            fileData.base64 = base64;
        } catch (error) {
            console.error('Error converting file to base64:', error);
            throw error;
        }
    } else {
        try {
            fileData.content = await extractTextFromFile(file);
            fileData.preview = URL.createObjectURL(file);
        } catch (error) {
            console.error('Error processing text file:', error);
            throw error;
        }
    }

    return fileData;
};

// Helper function to convert file to base64
const fileToBase64 = (file) => {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = (e) => resolve(e.target.result);
        reader.onerror = (e) => reject(e);
        reader.readAsDataURL(file);
    });
};